export const accentMap: Record<string, string> = {
  overline: 'bar',
  underline: 'under',
  widehat: 'hat',
  widetilde: 'tilde',
  hat: 'hat',
  tilde: 'tilde',
  vec: 'vec',
  bar: 'bar',
};
